import axios from 'axios';

// YTJ API Configuration
const YTJ_CONFIG = {
    BASE_URL: 'https://avoindata.prh.fi/opendata-ytj-api/v3',
    TIMEOUT: 10000,
};

/**
 * Fetch company data from YTJ (Finnish Business Information System)
 * @param {string} yTunnus - Finnish business ID in format 1234567-8
 * @returns {Promise<Object>} Company data
 */
export const fetchCompanyData = async (yTunnus) => {
    try {
        const config = {
            timeout: YTJ_CONFIG.TIMEOUT,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        };

        // Use the new v3 API with query parameter
        const response = await axios.get(`${YTJ_CONFIG.BASE_URL}/companies?businessId=${yTunnus}`, config);
        
        if (!response.data || !response.data.companies || response.data.companies.length === 0) {
            throw new Error('Yrityksen tietoja ei löytynyt.');
        }

        const companyData = response.data.companies[0];
        
        // Extract company information from the new v3 response structure with Finnish localization
        const latestName = companyData.names?.[0]?.name || '';
        const latestAddress = companyData.addresses?.find((a) => a.type === 1); // Type 1 = street address
        const mainBusinessLine = companyData.mainBusinessLine?.descriptions?.find(d => d.languageCode === '1')?.description || '';
        const companyForm = companyData.companyForms?.[0]?.descriptions?.find(d => d.languageCode === '1')?.description || '';
        
        // Get Finnish city name from postOffices
        const finnishCity = latestAddress?.postOffices?.find(p => p.languageCode === '1')?.city || '';

        return {
            companyName: latestName,
            address: latestAddress
                ? `${latestAddress.street} ${latestAddress.buildingNumber || ''}, ${latestAddress.postCode} ${finnishCity}`
                : '',
            website: '', // Website not available in v3 API
            registrationDate: companyData.businessId?.registrationDate,
            companyForm: companyForm,
            sector: mainBusinessLine,
        };
    } catch (error) {
        console.error('YTJ API Error:', error);
        
        if (error.response?.status === 404) {
            throw new Error('Yrityksen tietoja ei löytynyt.');
        } else if (error.response?.status === 401) {
            throw new Error('YTJ API autentikaatio epäonnistui.');
        } else if (error.response?.status === 429) {
            throw new Error('YTJ API kutsuiden määrä ylitetty. Yritä myöhemmin.');
        } else {
            throw new Error('Virhe haettaessa yrityksen tietoja.');
        }
    }
};

/**
 * Validate Y-tunnus format
 * @param {string} yTunnus - Finnish business ID
 * @returns {boolean} True if valid format
 */
export const validateYTunnus = (yTunnus) => {
    const yTunnusRegex = /^\d{7}-\d{1}$/;
    return yTunnusRegex.test(yTunnus);
};

 